<div data-testid="sales-order-view-page" class="p-6 max-w-6xl">
  <div class="flex items-center justify-between mb-6">
    <h2 class="text-2xl font-semibold text-gray-800">
      {{ "distribution.sales_order.view_title" | translate }}
      @if (order(); as o) {
        <span class="ml-2 text-gray-500">{{ o.series }}</span>
      }
    </h2>
    <div class="flex gap-2">
      @if (showApprove()) {
        <p-button
          data-testid="sales-order-approve-btn"
          severity="success"
          [label]="'common.actions.approve' | translate"
          (onClick)="onApprove()"
        />
      }
      @if (showRelease()) {
        <p-button
          data-testid="sales-order-release-btn"
          [label]="'distribution.actions.release' | translate"
          (onClick)="onRelease()"
        />
      }
      @if (showReject()) {
        <p-button
          data-testid="sales-order-reject-btn"
          severity="danger"
          [outlined]="true"
          [label]="'common.actions.reject' | translate"
          (onClick)="onReject()"
        />
      }
      @if (showCancel()) {
        <p-button
          data-testid="sales-order-cancel-btn"
          severity="danger"
          [outlined]="true"
          [label]="'distribution.actions.cancel_order' | translate"
          (onClick)="onCancel()"
        />
      }
      <p-button
        severity="secondary"
        [outlined]="true"
        [label]="'common.actions.back' | translate"
        (onClick)="onBack()"
      />
    </div>
  </div>

  @if (order(); as o) {
    <dl class="grid grid-cols-1 md:grid-cols-2 gap-x-8 gap-y-3 mb-6">
      <div>
        <dt class="text-sm text-gray-500">
          {{ "distribution.fields.series" | translate }}
        </dt>
        <dd>{{ o.series }}</dd>
      </div>
      <div>
        <dt class="text-sm text-gray-500">
          {{ "distribution.fields.status" | translate }}
        </dt>
        <dd>
          @if (o.status) {
            <p-tag
              data-testid="sales-order-status-tag"
              [value]="'distribution.status.order.' + o.status | translate"
              [severity]="statusSeverity(o.status)"
            />
          }
        </dd>
      </div>
      <div>
        <dt class="text-sm text-gray-500">
          {{ "distribution.fields.dealer_code" | translate }}
        </dt>
        <dd>{{ o.vendorCode }}</dd>
      </div>
      <div>
        <dt class="text-sm text-gray-500">
          {{ "distribution.fields.delivery_date" | translate }}
        </dt>
        <dd>{{ o.deliveryDate | date: "dd/MM/yyyy" }}</dd>
      </div>
      <div>
        <dt class="text-sm text-gray-500">
          {{ "distribution.fields.posting_date" | translate }}
        </dt>
        <dd>{{ o.postingDate | date: "dd/MM/yyyy" }}</dd>
      </div>
      <div>
        <dt class="text-sm text-gray-500">
          {{ "distribution.fields.sales_request" | translate }}
        </dt>
        <dd>
          @if (o.salesRequestId) {
            <a
              class="text-blue-600 underline"
              [href]="'/distribution/sales-request/view/' + o.salesRequestId"
              >#{{ o.salesRequestId }}</a
            >
          } @else {
            -
          }
        </dd>
      </div>
      <div class="md:col-span-2">
        <dt class="text-sm text-gray-500">
          {{ "distribution.fields.description" | translate }}
        </dt>
        <dd>{{ o.description || "-" }}</dd>
      </div>
    </dl>

    <h3 class="text-lg font-semibold mb-2">
      {{ "distribution.fields.items" | translate }}
    </h3>
    <p-table
      data-testid="sales-order-items-table"
      [value]="o.items ?? []"
      styleClass="mb-6"
    >
      <ng-template pTemplate="header">
        <tr>
          <th>{{ "distribution.fields.sku_code" | translate }}</th>
          <th>{{ "distribution.fields.quantity" | translate }}</th>
          <th>{{ "distribution.fields.unit_price" | translate }}</th>
          <th>{{ "distribution.fields.tax" | translate }}</th>
          <th>{{ "distribution.fields.warehouse" | translate }}</th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-item>
        <tr>
          <td>{{ item.skuCode }}</td>
          <td>{{ item.quantity | number: "1.0-3" }}</td>
          <td>{{ item.unitPrice | number: "1.0-2" }}</td>
          <td>{{ item.tax | number: "1.0-2" }}</td>
          <td>{{ item.warehouseCode }}</td>
        </tr>
      </ng-template>
    </p-table>

    <h3 class="text-lg font-semibold mb-2">
      {{ "distribution.fields.outbounds" | translate }}
    </h3>
    <p-table data-testid="sales-order-outbounds-table" [value]="o.outbounds ?? []">
      <ng-template pTemplate="header">
        <tr>
          <th>{{ "distribution.fields.warehouse" | translate }}</th>
          <th>{{ "distribution.fields.odo_code" | translate }}</th>
          <th>{{ "distribution.fields.status" | translate }}</th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-outbound>
        <tr>
          <td>{{ outbound.warehouseCode }}</td>
          <td>{{ outbound.odoCode }}</td>
          <td>
            @if (outbound.status) {
              <p-tag
                [value]="'distribution.status.outbound.' + outbound.status | translate"
                [severity]="outboundStatusSeverity(outbound.status)"
              />
            }
          </td>
        </tr>
      </ng-template>
      <ng-template pTemplate="emptymessage">
        <tr>
          <td colspan="3" class="text-center text-gray-500">
            {{ "distribution.sales_order.no_outbounds" | translate }}
          </td>
        </tr>
      </ng-template>
    </p-table>
  }
</div>

<p-confirmDialog
  [acceptLabel]="'common.actions.confirm' | translate"
  [rejectLabel]="'common.actions.cancel' | translate"
/>
<p-toast />
